import { render } from "./CreateStockInView.vue?vue&type=template&id=0df5b7bc&scoped=true"
import script from "./CreateStockInView.vue?vue&type=script&lang=js"
export * from "./CreateStockInView.vue?vue&type=script&lang=js"

import "./CreateStockInView.vue?vue&type=style&index=0&id=0df5b7bc&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df5b7bc"]])

export default __exports__